import { createClient } from "@sanity/client";
import imageUrlBuilder from '@sanity/image-url'

const client = createClient({
  projectId: "apokw1o1",
  dataset: "production",
  useCdn: true,
  apiVersion: '2024-05-25'
})

const builder = imageUrlBuilder(client)

export const urlFor = (source) => builder.image(source).auto('format').fit('max')

export default client